// @vendor
const React = require('react');
const PropTypes = require('prop-types');

//@core
const { formatText } = require('core/i18n').i18n;

//@components
const PopoverNavigationButton = require('components/commons/popoverNavigationButton/popoverNavigationButton');

//@constants
const DEPOSITS_PRODUCT_BANNERS = require ('constants/productBanners/depositsProductBanners');
const CC_DEPOSITS_PRODUCT_BANNERS = require ('constants/contactCenter/depositsProductBanners');


class DepositsProductDropdown extends React.Component {
    render() {
        const { customClassName, dropdownItemStyle, flagBasedFeatures } = this.props;

        const banners = Object.assign(CC_DEPOSITS_PRODUCT_BANNERS, DEPOSITS_PRODUCT_BANNERS);
        const orderedProductBanners = Object.keys(banners);

        const title = formatText('hireDepositsDropdown-title');
        const items = orderedProductBanners
        .map(bannerKey => banners[bannerKey])
        .filter(banner => !banner.featureFlag || flagBasedFeatures.get(banner.featureFlag))
        .map(banner => ({
                link: banner.link,
                text: formatText(banner.title),
            })
        );

        return (
            <PopoverNavigationButton
                customClassName={customClassName}
                dropdownItemStyle={dropdownItemStyle}
                title={title}
                items={items}
            />
        );
    }
}

DepositsProductDropdown.propTypes = {
    customClassName: PropTypes.string,
    dropdownItemStyle: PropTypes.string,
    flagBasedFeatures: PropTypes.object,
};

module.exports = DepositsProductDropdown;
